import { render, staticRenderFns } from "./FlowRecover.vue?vue&type=template&id=460ca205&scoped=true"
import script from "./FlowRecover.vue?vue&type=script&lang=js"
export * from "./FlowRecover.vue?vue&type=script&lang=js"
import style0 from "./FlowRecover.vue?vue&type=style&index=0&id=460ca205&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ca205",
  null
  
)

export default component.exports